module.exports = __webpack_public_path__ + "img/1723776940569-image.jpg.19cff8bb.webp";